// extracted by mini-css-extract-plugin
module.exports = {"title":"IppicaRisultatiRenderer_title___Fmpv","noBorderRadiusTop":"IppicaRisultatiRenderer_noBorderRadiusTop__ZRMW_","noMarginRigth":"IppicaRisultatiRenderer_noMarginRigth__c2vEJ"};